import React from 'react';
import { Close12, ArrowRight16 } from '@honeybook/icons';
import HBText from '../../../HBText/HBText';
import HBIconButton from '../../../HBIconButton/HBIconButton';
import HBLinkButton from '../../../HBLinkButton/HBLinkButton';
import {
    StyledWidget,
    WidgetPrefixWrapper,
    ContentAndActionContainer,
    PrefixAndContentContainer,
    ContentArea,
    TitleRow,
    IconWrapper
} from './HBSideNavWidgetDismissible.styles';
import { HBSideNavWidgetDismissibleProps } from './HBSideNavWidgetDismissible.types';
import { useSideDrawer } from '../../../HBSideDrawer/HBSideDrawer';

export const HBSideNavWidgetDismissible: React.FC<
    HBSideNavWidgetDismissibleProps
> = ({
    onDismiss,
    title,
    titlePrefix,
    widgetPrefix,
    children,
    action,
    testId,
    hideWhenCollapsed = true
}) => {
    const { drawerState } = useSideDrawer();

    const handleDismiss = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        onDismiss?.(e);
    };

    if (hideWhenCollapsed && drawerState === 'collapsed') {
        return null;
    }

    return (
        <StyledWidget testId={testId}>
            {widgetPrefix && (
                <WidgetPrefixWrapper>
                    <IconWrapper>{widgetPrefix}</IconWrapper>
                </WidgetPrefixWrapper>
            )}
            <ContentAndActionContainer
                $drawerState={drawerState}
                $hasWidgetPrefix={!!widgetPrefix}
            >
                <PrefixAndContentContainer>
                    <ContentArea>
                        {title && (
                            <TitleRow>
                                {titlePrefix && (
                                    <IconWrapper>{titlePrefix}</IconWrapper>
                                )}
                                <HBText type="title14" color="white">
                                    {title}
                                </HBText>
                            </TitleRow>
                        )}
                        {children && (
                            <HBText type="body14" weight="400" color="white">
                                {children}
                            </HBText>
                        )}
                        {action && (
                            <HBLinkButton
                                size="sm"
                                linkButtonTheme="link-button-accent"
                                icon={<ArrowRight16 />}
                                iconPosition="end"
                                alignment="start"
                                testId={testId ? `${testId}-action` : undefined}
                            >
                                {action}
                            </HBLinkButton>
                        )}
                    </ContentArea>
                </PrefixAndContentContainer>
                {onDismiss && drawerState === 'expanded' && (
                    <HBIconButton
                        icon={Close12}
                        label="Dismiss"
                        size="xxs"
                        buttonTheme="light-invisible"
                        onClick={handleDismiss}
                        testId={testId ? `${testId}-dismiss` : undefined}
                    />
                )}
            </ContentAndActionContainer>
        </StyledWidget>
    );
};
